/* eslint-disable no-prototype-builtins,no-restricted-syntax */
import api from '../../utils/apiFetch';

export default {
  getListSchemaApi: () => api.get(`tickets/seatmap-schemas`),
  setSchemaRelationShipApi: (payload) =>
    api.post(`tickets/seatmap-schema-relationship`, payload),
  getSchemaRelationShipApi: () =>
    api.get(`tickets/seatmap-schema-relationships`),
  getItemsByTicketing: (payload) =>
    api.get(`tickets/list-publish-event/?merchantId=${payload}`),
};
